import type { FunctionComponent } from 'react';

import type { BlocklistResult } from '@ballerine/business-analysis-schemas';

import { ExternalLink } from '../../../../common/icons/lucide-adapter';
import { QuestionMarkTooltip } from '../components';
import { BlocklistStatusBadge } from './BlocklistStatusBadge';

type BlocklistHeaderFieldProps = {
  blocklist?: BlocklistResult | null;
  configUrl?: string;
  className?: string;
};

export const BlocklistHeaderField: FunctionComponent<BlocklistHeaderFieldProps> = ({
  blocklist,
  configUrl,
  className,
}) => {
  if (!blocklist) {
    return null;
  }

  return (
    <div className={className}>
      <div className="mb-2 flex items-center gap-1">
        <h4 className="text-sm font-semibold text-stone-400">BLOCKLIST</h4>
        <QuestionMarkTooltip
          text="Whether the merchant's declared or extracted details appear in the customer's blocklist."
          className="ml-2"
        />
      </div>
      <div className="flex items-center gap-2">
        <BlocklistStatusBadge blocklist={blocklist} />
        {/* Blocklisted reports carry the config link in the Blocklist section below — no duplicate here. */}
        {configUrl && blocklist.status !== 'alert' && (
          <a
            href={configUrl}
            target="_blank"
            rel="noreferrer"
            aria-label="Open blocklist configuration"
            className="text-[#007aff] hover:text-blue-600"
          >
            <ExternalLink className="h-3 w-3" />
          </a>
        )}
      </div>
    </div>
  );
};
